import React, { PropsWithChildren } from "react";
import { Else, If, Then } from "react-if";
import LoadingPanel from "@/components/LodingPanel";

export const OverlayLoading: React.FC<{
  loading: boolean;
  backgroundColor?: boolean;
}> = ({ loading, backgroundColor = true }) => {
  if (!loading) return null;
  return (
    <div
      style={{
        backgroundColor: backgroundColor
          ? "var(--tlx-color-neutral-white-200)"
          : "transparent",
        position: "absolute",
        zIndex: 2000,
        top: 0,
        left: 0,
        bottom: 0,
        right: 0,
      }}
    >
      <div
        className="k-loading-image"
        style={{
          width: "100%",
          height: "6.25rem",
          boxSizing: "border-box",
          position: "relative",
          left: "50%",
          top: "50%",
          transform: "translate(-50%, -50%)",
        }}
      />
    </div>
  );
};

export const PageLoading: React.FC<
  {
    isLoading?: boolean;
  } & PropsWithChildren
> = ({ isLoading, children }) => {
  return (
    <If condition={isLoading}>
      <Then>
        <LoadingPanel />
      </Then>
      <Else>{children}</Else>
    </If>
  );
};

export const Loading: React.FC<{ isLoading?: boolean }> = ({ isLoading }) => {
  if (!isLoading) return null;
  return (
    <div
      style={{
        margin: "auto",
        textAlign: "center",
        minHeight: 100,
        width: "80%",
        paddingTop: 10,
        display: "flex",
        alignItems: "center",
      }}
    >
      <span className="k-loading-text">Loading</span>
      <div
        className="k-loading-image"
        style={{
          width: "100%",
          height: "100%",
          boxSizing: "border-box",
          position: "relative",
          left: "auto",
        }}
      />
    </div>
  );
};
